"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var input_1 = require("../input");
var React = require("react");
var DEFAULT_COLON = ":";
var DEFAULT_VALUE_SHORT = "00" + DEFAULT_COLON + "00";
function isNumber(value) {
    var valueNumber = Number(value);
    return !isNaN(valueNumber) && String(value) === String(valueNumber);
}
exports.isNumber = isNumber;
function formatTimeItem(value) {
    return ((value || "") + "00").substr(0, 2);
}
exports.formatTimeItem = formatTimeItem;
function convertToSeconds(validatedTime, colon) {
    if (colon === void 0) { colon = DEFAULT_COLON; }
    var _a = validatedTime.split(colon), M = _a[0], S = _a[1];
    return (Number(M) * 60 + Number(S));
}
exports.convertToSeconds = convertToSeconds;
function convertFromSeconds(value, colon) {
    if (colon === void 0) { colon = DEFAULT_COLON; }
    var _a = (value / 60 + "").split("."), M = _a[0], S = _a[1];
    S = (Number("0." + (S || 0)) * 60).toFixed().toString();
    (M.length === 1) && (M = "0" + M);
    (S.length === 1) && (S = "0" + S);
    return "" + M + colon + S;
}
exports.convertFromSeconds = convertFromSeconds;
function validateTimeAndCursor(value, defaultValue, colon, cursorPosition) {
    if (value === void 0) { value = ""; }
    if (defaultValue === void 0) { defaultValue = ""; }
    if (colon === void 0) { colon = DEFAULT_COLON; }
    if (cursorPosition === void 0) { cursorPosition = 0; }
    if (typeof value === "number") {
        value = convertFromSeconds(value);
    }
    var _a = defaultValue.split(colon), oldM = _a[0], oldS = _a[1];
    var newCursorPosition = Number(cursorPosition);
    var _b = String(value).split(colon), newM = _b[0], newS = _b[1];
    newM = formatTimeItem(newM);
    newS = formatTimeItem(newS);
    if (Number(newS[0]) > 5) {
        newS = oldS;
        newCursorPosition -= 1;
    }
    var validatedValue = "" + newM + colon + newS;
    return [validatedValue, newCursorPosition];
}
exports.validateTimeAndCursor = validateTimeAndCursor;
var TimeInput = /** @class */ (function (_super) {
    tslib_1.__extends(TimeInput, _super);
    function TimeInput(props) {
        var _this = _super.call(this, props) || this;
        _this.onChangeHandler = function (e) {
            var onChange = _this.props.onChange;
            _this.onInputChange(e, function (event, v) { return onChange && onChange(event, v); });
        };
        var defaultValue = DEFAULT_VALUE_SHORT;
        var colon = props.colon && props.colon.length === 1 ? props.colon : DEFAULT_COLON;
        var validatedTime = validateTimeAndCursor(_this.props.value, defaultValue, colon)[0];
        _this.state = {
            value: validatedTime,
            colon: colon,
            defaultValue: defaultValue,
            _maxLength: defaultValue.length
        };
        _this.onInputChange = _this.onInputChange.bind(_this);
        return _this;
    }
    TimeInput.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (this.props.value !== prevProps.value) {
            var validatedTime = validateTimeAndCursor(this.props.value, this.state.defaultValue, this.state.colon)[0];
            this.setState(tslib_1.__assign({}, this.state, { value: validatedTime }));
        }
    };
    TimeInput.prototype.onInputChange = function (e, callback) {
        var oldValue = this.state.value;
        var inputEl = e.target;
        var inputValue = inputEl.value;
        var position = inputEl.selectionEnd || 0;
        var isTyped = inputValue.length > oldValue.length;
        var cursorCharacter = inputValue[position - 1];
        var addedCharacter = isTyped ? cursorCharacter : null;
        var removedCharacter = isTyped ? null : oldValue[position];
        var replacedSingleCharacter = inputValue.length === oldValue.length ? oldValue[position - 1] : null;
        var colon = this.state.colon;
        var newValue = oldValue;
        var newPosition = position;
        if (addedCharacter !== null) {
            if (position > this.state._maxLength) {
                newPosition = this.state._maxLength;
            }
            else if ((position === 3 || position === 6) && addedCharacter === colon) {
                newValue = "" + inputValue.substr(0, position - 1) + colon + inputValue.substr(position + 1);
            }
            else if ((position === 3 || position === 6) && isNumber(addedCharacter)) {
                newValue = "" + inputValue.substr(0, position - 1) + colon + addedCharacter + inputValue.substr(position + 2);
                newPosition = position + 1;
            }
            else if (isNumber(addedCharacter)) {
                // user typed a number
                newValue = inputValue.substr(0, position - 1) + addedCharacter + inputValue.substr(position + 1);
                if (position === 2 || position === 5) {
                    newPosition = position + 1;
                }
            }
            else {
                // if user typed NOT a number, then keep old value & position
                newPosition = position - 1;
            }
        }
        else if (replacedSingleCharacter !== null) {
            // user replaced only a single character
            if (isNumber(cursorCharacter)) {
                if (position - 1 === 2 || position - 1 === 5) {
                    newValue = "" + inputValue.substr(0, position - 1) + colon + inputValue.substr(position);
                }
                else {
                    newValue = inputValue;
                }
            }
            else {
                // user replaced a number on some non-number character
                newValue = oldValue;
                newPosition = position - 1;
            }
        }
        else if (typeof cursorCharacter !== "undefined" && cursorCharacter !== colon && !isNumber(cursorCharacter)) {
            // set of characters replaced by non-number
            newValue = oldValue;
            newPosition = position - 1;
        }
        else if (removedCharacter !== null) {
            if ((position === 2 || position === 5) && removedCharacter === colon) {
                newValue = inputValue.substr(0, position - 1) + "0" + colon + inputValue.substr(position);
                newPosition = position - 1;
            }
            else {
                // user removed a number
                newValue = inputValue.substr(0, position) + "0" + inputValue.substr(position);
            }
        }
        var _a = validateTimeAndCursor(newValue, oldValue, colon, newPosition), validatedTime = _a[0], validatedCursorPosition = _a[1];
        var seconds = convertToSeconds(validatedTime, colon);
        this.setState(tslib_1.__assign({}, this.state, { value: validatedTime }), function () {
            inputEl.selectionStart = validatedCursorPosition;
            inputEl.selectionEnd = validatedCursorPosition;
            callback(e, { validatedTime: validatedTime, seconds: seconds });
        });
        e.persist();
    };
    TimeInput.prototype.render = function () {
        var value = this.state.value;
        var _a = this.props, style = _a.style, colon = _a.colon, props = tslib_1.__rest(_a, ["style", "colon"]);
        return (React.createElement(input_1.FormInput, tslib_1.__assign({ type: "text" }, props, { value: value, onChange: this.onChangeHandler, style: tslib_1.__assign({ width: 70 }, style) })));
    };
    TimeInput.defaultProps = {
        style: {},
        colon: DEFAULT_COLON
    };
    return TimeInput;
}(React.Component));
exports.default = TimeInput;
